import React from 'react';
import PropTypes from 'prop-types';

import {Button} from 'react-bootstrap';
import {FmlxButton} from 'fmlx-common-ui';
import HeaderLayout from '../Layout/HeaderLayout';

import './WizardHeader.scss';

function WizardHeader({
  backButtonText,
  hideBackButton,
  hideNextButton,
  disableBackButton,
  onBackClick,
  nextButtonText,
  disableNextButton,
  onNextClick,
  cancelButtonText,
  hideCancelButton,
  disableCancelButton,
  onCancelClick,
  customButtons,
  children,
}) {
  const renderCustomButons = () =>
    customButtons.map((buttonProp) => (
      <Button
        key={buttonProp.text}
        className="button-secondary"
        disabled={buttonProp.disabled}
        onClick={buttonProp.onClick}
      >
        {buttonProp.text}
      </Button>
    ));

  return (
    <HeaderLayout className="wizard-header">
      <HeaderLayout.Left className="flex-1">&nbsp;</HeaderLayout.Left>
      <HeaderLayout.Center>{children}</HeaderLayout.Center>
      <HeaderLayout.Right className="flex-1 gap padding-right">
        {!hideCancelButton && (
          <FmlxButton variant="plain" onClick={onCancelClick} disabled={disableCancelButton} label={cancelButtonText} />
        )}
        {renderCustomButons()}
        {!hideBackButton && (
          <FmlxButton
            type="warning"
            variant="outline"
            onClick={onBackClick}
            disabled={disableBackButton}
            label={backButtonText}
          />
        )}
        {!hideNextButton && (
          <FmlxButton type="warning" onClick={onNextClick} disabled={disableNextButton} label={nextButtonText} />
        )}
      </HeaderLayout.Right>
    </HeaderLayout>
  );
}

WizardHeader.propTypes = {
  backButtonText: PropTypes.string,
  hideBackButton: PropTypes.bool,
  disableBackButton: PropTypes.bool,
  onBackClick: PropTypes.func,
  nextButtonText: PropTypes.string,
  disableNextButton: PropTypes.bool,
  onNextClick: PropTypes.func,
  cancelButtonText: PropTypes.string,
  hideCancelButton: PropTypes.bool,
  disableCancelButton: PropTypes.bool,
  onCancelClick: PropTypes.func.isRequired,
  children: PropTypes.any.isRequired,
  customButtons: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      onClick: PropTypes.func.isRequired,
      disabled: PropTypes.bool,
    }),
  ),
  hideNextButton: PropTypes.bool,
};

WizardHeader.defaultProps = {
  customButtons: [],
  backButtonText: 'BACK',
  hideBackButton: false,
  disableBackButton: false,
  nextButtonText: 'NEXT',
  disableNextButton: false,
  cancelButtonText: 'CANCEL',
  hideCancelButton: false,
  disableCancelButton: false,
  hideNextButton: false,
  onBackClick: () => {},
  onNextClick: () => {},
};

export default WizardHeader;
